gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);

let mm = gsap.matchMedia();

const lenis = new Lenis({
	duration: 1.2,
	easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
	direction: 'vertical',
	gestureDirection: 'vertical',
	smooth: true,
	mouseMultiplier: 1,
	smoothTouch: false,
	touchMultiplier: 2,
	infinite: false,
	overscroll: true,
});

lenis.on('scroll', ScrollTrigger.update);

gsap.ticker.add((time) => {
	lenis.raf(time * 1000);
});

// Split menu items into two columns
const menuItems = gsap.utils.toArray('.list-item');

if (menuItems.length > 0) {
	const parent = menuItems[0].parentNode;
	const columnLeft = document.createElement('div');
	const columnRight = document.createElement('div');

	columnLeft.className = 'column-left';
	columnRight.className = 'column-right';

	// const midpoint = Math.floor(menuItems.length / 2);
	const midpoint = Math.ceil(menuItems.length / 2) - 1;

	menuItems.forEach((item, index) => {
		(index < midpoint ? columnLeft : columnRight).appendChild(item);
	});

	parent.append(columnLeft, columnRight);
}

const header = document.querySelector('.header-wrapper');
let lastScroll = 0;

let lastDirection = null;
const directionBuffer = 5; // pixel threshold for direction change
const progressThreshold = 0.1; // 10% scroll progress

lenis.on('scroll', ({ scroll }) => {
	const currentScroll = scroll;
	const delta = currentScroll - lastScroll;
	const scrollProgress =
		currentScroll / (document.body.scrollHeight - window.innerHeight);
	const absDelta = Math.abs(delta);
	const activeMegaMenu = document.querySelector('.mega-menu[open]');

	if (scrollProgress > progressThreshold) {
		header.classList.add('has-bg');

		if (absDelta > directionBuffer) {
			const newDirection = delta > 0 ? 'down' : 'up';
			if (newDirection !== lastDirection) {
				if (newDirection === 'down') {
					header.classList.remove('show');
					header.classList.add('hide');
					if (activeMegaMenu) {
						activeMegaMenu.classList.remove('show');
						activeMegaMenu.classList.add('hide');
					}
				} else {
					header.classList.remove('hide');
					header.classList.add('show');
					if (activeMegaMenu) {
						activeMegaMenu.classList.remove('hide');
						activeMegaMenu.classList.add('show');
					}
				}
				lastDirection = newDirection;
			}
		}
	} else {
		header.classList.remove('has-bg', 'hide', 'show');
		lastDirection = null;
	}

	lastScroll = currentScroll;
});

ScrollTrigger.defaults({
	scroller: document.querySelector('body'),
});

$(document).ready(function () {
	// Age Gate Logic
	const ageGateTimeline = gsap.timeline({
		id: 'age-gate-animation',
	});

	// play button replays the animation
	$('.play-button').on('click', () => {
		ageGateTimeline.restart();
	});

	const letters = document.querySelectorAll('.letter');

	// Check on page load
	if (!Cookies.get('ageGateDismissed')) {
		// User hasn't dismissed age gate - show it and run animation
		$('.age-gate').show();

		// Animate each letter with a stagger
		if (letters.length) {
			ageGateTimeline.to(letters, {
				yPercent: -100,
				duration: 1,
				ease: 'expo.out',
				stagger: 0.06,
			});
		}

		if ($('.age-gate').length) {
			ageGateTimeline.to(
				'.age-gate-content',
				{
					opacity: 1,
					transform: 'translateY(0)',
					duration: 0.7,
					ease: 'power2.out',
				},
				'-=1.3'
			);
		}

		if ($('.loader-bottle').length) {
			ageGateTimeline.to(
				'.loader-bottle',
				{
					opacity: 1,
					transform: 'translateY(0)',
					duration: 0.7,
					ease: 'power2.out',
				},
				'-=1'
			);
		}

		if ($('.loader-circle-glow').length) {
			ageGateTimeline.to(
				'.loader-circle-glow',
				{
					opacity: 1,
				},
				'-=.9'
			);
		}
	} else {
		// User has already dismissed age gate - hide immediately without animation
		$('.age-gate').hide();
		$('.age-gate-content').remove();
		$('.loader-overlay').remove();
	}

	// On confirm
	$('.age-gate-button-yes').on('click', () => {
		Cookies.set('ageGateDismissed', 'false', { expires: 10 }); // 10 days

		ageGateTimeline.to('.loader-overlay', {
			opacity: 0,
			duration: 0.5,
		});

		ageGateTimeline.to(
			'.age-gate-content',
			{
				opacity: 0,
				duration: 0.7,
			},
			'-=0.7'
		);

		ageGateTimeline.to(
			'.loader-bottle',
			{
				opacity: 0,
				duration: 0.7,
				scale: 0.9,
			},
			'-=0.7'
		);

		ageGateTimeline.to(
			'.letter-bottom',
			{
				yPercent: -200,
				duration: 1,
				ease: 'expo.out',
				stagger: 0.06,
			},
			'-=0.7'
		);

		ageGateTimeline.to(
			'.loader-circle-glow',
			{
				clipPath: 'circle(100% at 50% 50%)',
				duration: 1,
				ease: 'power2.out',
			},
			'-=1.1'
		);

		ageGateTimeline.to(
			$('.age-gate'),
			{
				opacity: 0,
				duration: 0.7,
				ease: 'power5.inOut',

				onComplete: () => {
					$('.age-gate').hide();
				},
			},
			'+=0.1'
		);
	});

	// No click: show message under buttons
	$('.age-gate-button-no').on('click', () => {
		$('.age-gate-message').fadeIn();
	});

	// On mouseenter, open the parent <details> and set aria-expanded
	$('#HeaderMenu-products').on('mouseenter', function () {
		$(this).attr('aria-expanded', 'true');
		const $parentDetails = $(this).closest('details');
		if ($parentDetails.length) {
			$parentDetails.attr('open', true);
			$parentDetails.addClass('show').removeClass('hide');
		}
	});

	// On mouseleave from the <details>, close it and set aria-expanded to false
	$('#HeaderMenu-MenuList-3').on('mouseleave', function () {
		$(this).closest('details').attr('aria-expanded', 'false');
		$(this).closest('details').removeAttr('open');
		$(this).closest('details').removeClass('show').addClass('hide');
	});

	// if ($('.floating-region').length) {
	// 	if (window.location.pathname.includes('/products/')) {
	// 		const floatingRegion = document.querySelector('.floating-region');
	// 		const productInfo = document.querySelector(
	// 			'.product__info-wrapper.grid__item'
	// 		);

	// 		if (productInfo) {
	// 			const observer = new IntersectionObserver(
	// 				(entries) => {
	// 					entries.forEach((entry) => {
	// 						if (entry.isIntersecting) {
	// 							floatingRegion.classList.add('visible');
	// 						} else {
	// 							floatingRegion.classList.remove('visible');
	// 						}
	// 					});
	// 				},
	// 				{ threshold: 0 }
	// 			);

	// 			observer.observe(productInfo);
	// 		}
	// 	}
	// }

	// if (!lenis) return;
	// Only apply parallax effects on screens 300px and larger
	if (window.innerWidth >= 300) {
		// Clear existing ScrollTriggers for [data-speed] elements before re-adding
		ScrollTrigger.addEventListener('refreshInit', () => {
			// ScrollTrigger.getAll().forEach((trigger) => {
			//     if (
			//         trigger.trigger &&
			//         trigger.trigger.querySelector &&
			//         trigger.trigger.querySelector('[data-speed]')
			//     ) {
			//         trigger.kill(); // remove existing to prevent duplicates
			//     }
			// });

			gsap.utils.toArray('[data-speed]').forEach((element) => {
				const parentSection =
					element.closest('.block') || element.closest('.foe-section');
				if (!parentSection) return;

				const speed = parseFloat(element.dataset.speed) || 1;
				const heightDiff = Math.max(
					0,
					element.offsetHeight - parentSection.offsetHeight
				);
				const offset = heightDiff * speed;

				// Create timeline for parallax effect
				const tl = gsap.timeline({
					scrollTrigger: {
						trigger: parentSection,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
						invalidateOnRefresh: true,
					},
				});

				// Add different animations based on screen size
				mm.add('(max-width: 600px)', () => {
					tl.fromTo(
						element,
						{ y: -offset * 0.3 }, // Reduced offset for mobile
						{ y: 0, ease: 'none' }
					);
				});

				mm.add('(min-width: 601px)', () => {
					tl.fromTo(element, { y: -offset }, { y: 0, ease: 'none' });
				});
			});
		});
	}

	if ($('.scrolling-botanical').length) {
		const botanicals = gsap.utils.toArray('.scrolling-botanical');
		botanicals.forEach((botanical, index) => {
			gsap.to(botanical, {
				y:
					index === 0
						? '30%'
						: index === 1
							? '-33%'
							: index === 2
								? '50%'
								: index === 3
									? '-40%'
									: '35%',
				ease: 'none',
				scrollTrigger: {
					trigger: botanical,
					start: 'top bottom',
					end: 'bottom top',
					scrub: true,
				},
			});
		});
	}

	if ($('.large-text-section .boatanical-images').length) {
		const section = $('.large-text-section');
		const boatanicalImages = gsap.utils.toArray('.boatanical-image');

		if ($('.boatanical-image-1').length) {
			gsap.to('.boatanical-image-1', {
				scrollTrigger: {
					trigger: section,
					start: 'top bottom',
					end: 'bottom top',
					scrub: true,
				},
				rotate: 20,
				y: 25,
			});
		}

		if ($('.boatanical-image-2').length) {
			gsap.to('.boatanical-image-2', {
				scrollTrigger: {
					trigger: section,
					start: 'top bottom',
					end: 'bottom top',
					scrub: true,
				},
				y: 30,
				rotate: -15,
			});
		}

		if ($('.boatanical-image-3').length) {
			gsap.to('.boatanical-image-3', {
				scrollTrigger: {
					trigger: section,
					start: 'top bottom',
					end: 'bottom top',
					scrub: true,
				},
				y: -75,
				rotate: 10,
			});
		}
	}

	if (document.querySelector('.featured-items')) {
		document.querySelectorAll('.featured-item').forEach((item) => {
			const top = item.querySelector('.char-split-top');
			const bottom = item.querySelector('.char-split-bottom');

			if (!top || !bottom) return;

			const topSplit = new SplitText(top, { type: 'chars' });
			const bottomSplit = new SplitText(bottom, { type: 'chars' });

			item.dataset.topChars = JSON.stringify(
				topSplit.chars.map((c) => c.outerHTML)
			);
			item.dataset.bottomChars = JSON.stringify(
				bottomSplit.chars.map((c) => c.outerHTML)
			);

			gsap.set(bottomSplit.chars, { yPercent: 100 });

			item.addEventListener('mouseenter', () => {
				if (!item.classList.contains('active')) {
					item.classList.add('active');

					topSplit.chars.forEach((char, i) => {
						gsap.to(char, {
							yPercent: -100,
							duration: 0.5,
							ease: 'power2.out',
							delay: i * 0.02,
						});
					});

					bottomSplit.chars.forEach((char, i) => {
						gsap.to(char, {
							yPercent: 0,
							duration: 0.5,
							ease: 'power2.out',
							delay: i * 0.02,
						});
					});
				}

				document.querySelectorAll('.featured-item').forEach((other) => {
					if (other !== item) other.classList.remove('active');
				});
			});

			item.addEventListener('mouseleave', () => {
				topSplit.chars.forEach((char, i) => {
					gsap.to(char, {
						yPercent: 0,
						duration: 0.4,
						ease: 'power2.out',
						delay: i * 0.02,
					});
				});

				bottomSplit.chars.forEach((char, i) => {
					gsap.to(char, {
						yPercent: 100,
						duration: 0.4,
						ease: 'power2.out',
						delay: i * 0.02,
					});
				});

				item.classList.remove('active');
			});
		});

		const featuredItemsSwiper = new Swiper('.featured-items', {
			loop: false,
			slidesPerView: 'auto',
			spaceBetween: 24,
			clickable: true,

			breakpoints: {
				0: {
					slidesPerView: 1,
				},

				769: {
					slidesPerView: 3,
				},
			},
			navigation: {
				nextEl: '.featured-next',
				prevEl: '.featured-prev',
			},
			on: {
				slideChange: function () {
					mm.add('(max-width: 768px)', () => {
						const activeSlide = this.slides[this.activeIndex];
						const activeItem = activeSlide.querySelector('.featured-item');
						const topSplit = activeItem.querySelector('.char-split');
						const bottomSplit =
							activeItem.querySelector('.char-split-bottom');

						// Remove active class and reset animations from all slides
						this.slides.forEach((slide) => {
							const item = slide.querySelector('.featured-item');
							item.classList.remove('active');
							// this item is the active item
							if (item === activeItem) {
								item.classList.add('active');
							}

							// Reset all splits
							const topChars = item.querySelector('.char-split').children;
							const bottomChars =
								item.querySelector('.char-split-bottom').children;

							gsap.to(topChars, {
								yPercent: 0,
								duration: 0.4,
								ease: 'power2.out',
								stagger: 0.02,
							});

							gsap.to(bottomChars, {
								yPercent: 100,
								duration: 0.4,
								ease: 'power2.out',
								stagger: 0.02,
							});
						});

						// Add active class and animate current slide
						activeItem.classList.add('active');

						// Animate active slide splits
						gsap.to(topSplit.children, {
							yPercent: -100,
							duration: 0.5,
							ease: 'power2.out',
							stagger: 0.02,
						});

						gsap.to(bottomSplit.children, {
							yPercent: 0,
							duration: 0.5,
							ease: 'power2.out',
							stagger: 0.02,
						});
					});
				},
			},
		});
	}

	if ($('.foe-slider-grid-item').length) {
		// product thumbs swiper
		const productThumbnailSwiper = new Swiper('.product-thumbnail-slider', {
			loop: true,
			spaceBetween: 10,
			slidesPerView: 5,
			watchSlidesProgress: true,
			clickable: true,
		});

		// product main swiper with thumbs
		const productMainSlider = new Swiper('.product-main-slider', {
			loop: true,
			slidesPerView: 1,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			thumbs: {
				swiper: productThumbnailSwiper,
			},
		});

		const bottleTimeline = gsap.timeline({
			scrollTrigger: {
				trigger: $('.foe-product-container'),
				start: 'top 95%',
				end: 'bottom 10%',
			},
		});
		bottleTimeline.to('.foe-slider-wrapper', {
			clipPath: 'inset(0% 0% 0% 0%)',
			duration: 1,
			ease: 'expo.out',
		});

		bottleTimeline.to(
			'.product__info-wrapper',
			{
				opacity: 1,
				duration: 0.7,
				ease: 'power2.out',
			},
			'-=0.4'
		);

		bottleTimeline.to(
			'.bottle-image img',
			{
				opacity: 1,
				y: 0,
				duration: 1,
				ease: 'expo.out',
			},
			'-=0.5'
		);

		bottleTimeline.to(
			'.circle-glow',
			{
				opacity: 1,
				duration: 0.3,
				ease: 'expo.out',
			},
			'-=1.3'
		);

		bottleTimeline.to(
			'.circle-glow',
			{
				clipPath: 'circle(22% at 50% 50%)',
				duration: 0.3,
				ease: 'expo.out',
			},
			'-=1.3'
		);

		if ($('.product-featured-award').length) {
			bottleTimeline.to(
				'.product-featured-award',
				{
					opacity: 1,
					transform: 'scale(1)',
					duration: 0.3,
					ease: 'expo.out',
				},
				'-=1.3'
			);
		}

		bottleTimeline.to(
			'.product-thumbnail-slider',
			{
				opacity: 1,
				y: 0,
				duration: 1,
				ease: 'expo.out',
			},
			'-=1.2'
		);

		// After the initial animation completes, add an infinite pulse animation to the circle-glow
		bottleTimeline.to(
			'.circle-glow',
			{
				clipPath: 'circle(23% at 50% 50%)',
				duration: 2,
				ease: 'power1.inOut',
				repeat: -1,
				yoyo: true,
				repeatDelay: 0.2,
			},
			'-=0.2'
		);

		$('.replay-button').on('click', () => {
			bottleTimeline.restart();
		});
	}

	//Main Slider
	document.querySelectorAll('.slider-main').forEach(function (slider) {
		var id = slider.id;

		new Swiper(slider, {
			loop: false,
			speed: 750,
			slidesPerView: 'auto',

			// autoplay: {
			//     delay: 6000,
			//     disableOnInteraction: true,
			// },

			navigation: {
				nextEl: '.next-slide',
				prevEl: '.prev-slide',
			},

			breakpoints: {
				0: {
					slidesPerView: 1,
				},

				601: {
					slidesPerView: 'auto',
				},
			},
		});
	});

	// Ingredients Slider (only one instance expected)
	const ingredientsSlider = document.querySelector('.slider-ingredients');
	if (ingredientsSlider) {
		new Swiper(ingredientsSlider, {
			loop: true,
			speed: 750,
			effect: 'fade',
			navigation: {
				nextEl: '.next-country',
				prevEl: '.prev-country',
			},

			on: {
				slideChange: function () {
					// Get the active slide's data-country attribute
					const activeSlide = this.slides[this.activeIndex];
					const country = activeSlide.getAttribute('data-country');
					if (!country) return;

					// Change fill color for #country to yellow, all others to black
					$('.africa-map path').each(function () {
						if (this.id === country) {
							$(this).css('fill', '#FFC81A');
						} else {
							$(this).css('fill', 'black');
						}
					});
				},
			},
		});
	}

	$('.custom-cart').click(function () {
		if ($(this).hasClass('open')) {
			$('body').addClass('no-scroll');
			$(this).removeClass('open');
			// pause lenis
			lenis.stop();
		} else {
			$('body').removeClass('no-scroll');
			$(this).addClass('open');
			// resume lenis
			lenis.start();
		}
	});

	//Cocktail Filters
	$('.cocktail-filter-item').on('click', function () {
		const filterId = $(this).data('product-id');
		console.log(filterId);
		$('.cocktail-filter-item').removeClass('active');
		$(this).addClass('active');

		if (filterId === 'all') {
			$('.cocktail-card').show();
		} else {
			$('.cocktail-card').each(function () {
				const cardId = $(this).data('product-id');
				if (cardId == filterId) {
					$(this).show();
				} else {
					$(this).hide();
				}
			});
		}
		ScrollTrigger.refresh();
	});

	// $('.cocktail-filter-item')

	// Resume scrolling when drawer is closed
	$(document).on('click', '.drawer__close-button', function () {
		$('body').removeClass('no-scroll');
		$('.custom-cart').removeClass('open');
		// resume lenis
		lenis.start();
	});

	// Monitor drawer active state
	const drawerObserver = new MutationObserver(function (mutations) {
		mutations.forEach(function (mutation) {
			if (mutation.attributeName === 'class') {
				const drawer = $(mutation.target);
				if (!drawer.hasClass('active')) {
					lenis.start();
					$('.custom-cart').removeClass('open');
				}
			}
		});
	});

	// Start observing the drawer for class changes
	const drawer = document.querySelector('.drawer');
	if (drawer) {
		drawerObserver.observe(drawer, { attributes: true });
	}

	// Our Story Intro
	const galleryRow = document.querySelector('.gallery-row');
	if (galleryRow) {
		const galleryRowItems = gsap.utils.toArray(
			galleryRow.querySelectorAll('.row-img')
		);
		gsap.from(galleryRowItems, {
			xPercent: 50,
			opacity: 0,
			scrollTrigger: {
				trigger: galleryRow,
				start: 'top 90%',
				end: 'bottom 50%',
				scrub: 2,
			},
			stagger: 0.1,
			ease: 'power2.out',
		});

		gsap.from('.hero-text-wrapper', {
			opacity: 0,
			y: 100,
			scrollTrigger: {
				trigger: '.hero-text-wrapper',
				start: 'top 70%',
				end: 'bottom 15%',
				scrub: true,
			},
			ease: 'power2.out',
		});
	}

	// Sticky Hero Content
	$('.hero:not(.height-half)').each(function () {
		const heroContent = $(this).find('.hero-content');
		const bgOverlay = $(this).find('.hero-bg-overlay');

		// ScrollTrigger.create({
		//     trigger: heroContentParent,
		//     start: 'clamp(top top)',
		//     end: 'clamp(bottom top)',
		//     scrub: true,
		// });

		// Opacity animation trigger
		gsap.to(bgOverlay, {
			opacity: 1,
			scrollTrigger: {
				trigger: $('.hero'),
				start: 'clamp(top top)',
				end: `clamp(center 15%)`,
				scrub: true,
			},
		});
	});

	// Sticky Hero Content
	$('.sustainability-hero').each(function () {
		const heroContent = $(this).find('.hero-content');
		const bgOverlay = $('.sustainability-hero .hero-bg-overlay');

		// ScrollTrigger.create({
		//     trigger: heroContentParent,
		//     start: 'clamp(top top)',
		//     end: 'clamp(bottom top)',
		//     scrub: true,
		// });

		// Opacity animation trigger
		// gsap.fromTo(
		// 	bgOverlay,
		// 	{
		// 		opacity: 0.5,
		// 	},
		// 	{
		// 		opacity: 1,
		// 		scrollTrigger: {
		// 			trigger: $('.sustainability-hero'),
		// 			start: 'clamp(top top)',
		// 			end: `clamp(center 15%)`,
		// 			scrub: true,
		// 		},
		// 	}
		// );
	});

	// Africa SVG Animation
	$('.simple-text').each(function () {
		const svgContainer = $(this).find('.africa-svg');
		const textContent = $(this).find('.text-content');

		gsap.set(svgContainer, {
			opacity: 0,
		});

		// gsap.set(textContent, {
		// 	opacity: 0,
		// });

		const africaTimeline = gsap.timeline(
			{
				ease: 'power2.inOut',
				scrollTrigger: {
					trigger: $(this),
					start: 'top 85%',
					end: `bottom 50%`,
					scrub: 1,
				},
			},
			'-=0.5'
		);

		africaTimeline.to(svgContainer, {
			opacity: 1,
		});

		// africaTimeline.to(textContent, {
		// 	opacity: 1,
		// 	transform: 'translateY(0)',
		// });
	});

	if ($('.pinned-text-section').length > 0) {
		$('.pinned-text-section').each(function () {
			const section = $(this);
			const pinnedItem = section[0]; // Element to be pinned
			const bgImage = section.find('.bg-wrapper')[0]; // Element to animate
			const image = section.find('.bg-wrapper img')[0];
			const bgOverlay = section.find('.bg-overlay')[0];

			if (!pinnedItem || !bgImage) return;

			gsap.to(bgImage, {
				// clipPath: 'circle(150% at 50% 50%)',
				// ease: 'none',
				scrollTrigger: {
					trigger: section,
					start: 'top top',
					end: '+=800', // Adjust duration as needed
					pin: true,
					pinType: 'fixed', // Required for Lenis + native body
					pinSpacing: true, // Keep spacing to preserve layout
					scrub: true,
					invalidateOnRefresh: true,
				},
			});

			const pinnedTimeline = gsap.timeline({
				scrollTrigger: {
					trigger: section,
					start: 'top top',
					end: '+=800', // Adjust duration as needed
					scrub: true,
					invalidateOnRefresh: true,
				},
			});

			pinnedTimeline.to(
				bgImage,
				{
					clipPath: 'circle(150% at 50% 50%)',
					ease: 'none',
				},
				'0'
			);

			pinnedTimeline.to(
				image,
				{
					transform: 'scale(1)',
					ease: 'none',
				},
				'0'
			);

			pinnedTimeline.to(
				bgOverlay,
				{
					opacity: 1,
					ease: 'none',
				},
				'-=0.2'
			);
		});
	}

	//Horizontal Scrolling Text
	$('.scrolling-text-section').each(function () {
		const scrollingTextSection = $(this);
		const scrollingTextItems = Array.from(
			scrollingTextSection.find('.scrolling-text-item')
		);
		// console.log(scrollingTextItems.length);

		horizontalLoop(scrollingTextItems, {
			speed: 0.5,
			repeat: -1,
		});
	});

	//Announcement Bar
	if ($('.foe-announcement-bar').length) {
		const announcementBar = $(this);
		const announcementBarItems = Array.from(
			announcementBar.find('.scrolling-text-item')
		);
		horizontalLoop(announcementBarItems, {
			speed: 0.25,
			repeat: -1,
		});
	}

	$('.scrolling-images-section').each(function () {
		const scrollingImagesSection = $(this);
		const frontImages = gsap.utils.toArray(
			scrollingImagesSection.find('.front-scrolling-image')
		);
		const backImages = gsap.utils.toArray(
			scrollingImagesSection.find('.back-scrolling-image')
		);

		const frontLoop = horizontalLoop(frontImages, {
			paused: false,
			speed: 0.6,
			repeat: -1,
			center: true,
		});
		const backLoop = horizontalLoop(backImages, {
			paused: false,
			speed: 0.3,
			repeat: -1,
			center: true,
		});
	});

	// Slip line for headings
	if (window.innerWidth > 600) {
		const headingsList = document.querySelectorAll(
			'.heading-slide-up, .heading-slide-up h1, .heading-slide-up h2, .heading-slide-up h3, h1.heading-slide-up, h2.heading-slide-up, h3.heading-slide-up'
		);

		headingsList.forEach((element) => {
			const split = new SplitText(element, { type: 'lines' });

			// Wrap each line individually
			split.lines.forEach((line) => {
				const wrapper = document.createElement('div');
				wrapper.classList.add('line-wrapper');
				line.parentNode.insertBefore(wrapper, line);
				wrapper.appendChild(line);
			});

			// Animate all wrapped lines together
			const wrappedLines = element.querySelectorAll('.line-wrapper > *');

			gsap.from(wrappedLines, {
				y: 100,
				// rotate: -5,
				autoAlpha: 0,
				duration: 1,
				stagger: 0.1,
				ease: 'expo.out',
				scrollTrigger: {
					trigger: element,
					start: 'top 90%',
					end: 'bottom 10%',
					toggleActions: 'play none none none',
				},
			});
		});
	}

	// Blog Slider/Cocktail Feed
	$('.blog-slider').each(function (index) {
		const blogSlider = $(this)[0];
		const uniqueId = `blog-slider-${index}`;

		// Add unique classes for navigation elements
		$(this).find('.swiper-button-next').addClass(`${uniqueId}-next`);
		$(this).find('.swiper-button-prev').addClass(`${uniqueId}-prev`);

		// swiper setup with unique navigation selectors
		// Only initialize swiper on screens 1200px or smaller
		let swiper;
		function initSwiper() {
			if (window.innerWidth <= 1200) {
				swiper = new Swiper(blogSlider, {
					slidesPerView: 'auto',
					spaceBetween: 30,
					loop: true,
					navigation: {
						nextEl: `.${uniqueId}-next`,
						prevEl: `.${uniqueId}-prev`,
					},
					// pagination: {
					//     el: '.swiper-pagination',
					//     clickable: true,
					// },
				});
			} else if (swiper !== undefined) {
				swiper.destroy(true, true);
				swiper = undefined;
			}
		}

		// Initialize on load
		initSwiper();
		// Reinitialize on window resize
		window.addEventListener('resize', initSwiper);

		const cocktailLinks = gsap.utils.toArray($(blogSlider).find('.cocktail-link'));

		gsap.from(cocktailLinks, {
			opacity: 0,
			duration: 1.2,
			ease: 'power2.out',
			stagger: 0.1,
			scrollTrigger: {
				trigger: cocktailLinks,
				start: 'top 50%',
				toggleActions: 'play none none none',
			},
		});
	});

	// Footer Newsletter Open
	$('.footer-newsletter-trigger, a[href="#newsletter"]').on('click', (e) => {
		// At 749px and smaller, just navigate to the anchor
		if (window.innerWidth <= 749) {
			window.scrollTo({
				top: document.documentElement.scrollHeight,
				behavior: 'smooth',
			});
		} else {
			e.preventDefault();
			const $section = $('.footer-newsletter-section');

			if ($section.is(':visible')) {
				$section.slideUp(300);
			} else {
				$section.slideDown(300, () => {
					$section.css('display', 'block');

					// Wait for layout to fully apply
					setTimeout(() => {
						requestAnimationFrame(() => {
							window.scrollTo({
								top: document.documentElement.scrollHeight,
								behavior: 'smooth',
							});
						});
					}, 300);
				});
			}
		}
	});

	if ($('.product-about-section').length) {
		const tabNavItems = $('.tabs-nav .tab-item');
		const tabPanels = $('.tabs-content .tab-panel');

		tabNavItems.on('click', function () {
			const index = $(this).index();
			tabNavItems.removeClass('active').eq(index).addClass('active');

			// Hide all panels first
			tabPanels.removeClass('active');

			// Get the panel to show
			const activePanel = tabPanels.eq(index);

			// Add active class and animate with fadeIn
			activePanel.addClass('active').hide().fadeIn(300);
			// ScrollTrigger.refresh();
		});

		const botanicals = gsap.utils.toArray(
			$('.product-about-section').find('.botanical')
		);

		botanicals.forEach((botanical) => {
			// fade up
			gsap.from(botanical, {
				opacity: 0,
				y: 50,
				duration: 1,
				stagger: 0.2,
				ease: 'expo.out',
				scrollTrigger: {
					trigger: botanical,
					start: 'top 90%',
					end: 'bottom 10%',
					toggleActions: 'play none none none',
				},
			});
		});
	}

	if ($('.awards-slider').length) {
		const awardsSlider = $('.awards-slider');
		const awardsSliderSwiper = new Swiper('.awards-slider', {
			loop: true,
			slidesPerView: 4,
			spaceBetween: 10,
			breakpoints: {
				601: {
					slidesPerView: 4,
					spaceBetween: 20,
				},
				1024: {
					slidesPerView: 4,
					spaceBetween: 10,
				},
			},
		});

		const awardImages = gsap.utils.toArray($(awardsSlider).find('.award-image'));

		gsap.from(awardImages, {
			opacity: 0,
			duration: 1.2,
			ease: 'power2.out',
			stagger: 0.1,
			scrollTrigger: {
				trigger: awardImages,
				start: 'top 90%',
				toggleActions: 'play none none none',
			},
		});
	}

	if ($('.related-gins-section').length) {
		$('.gin-card').hover(
			function () {
				// On mouse enter
				$(this).addClass('active');
				$('.gin-card').not(this).addClass('blur');
			},
			function () {
				// On mouse exit
				$(this).removeClass('active');
				$('.gin-card').removeClass('blur');
			}
		);
	}

	$('.header-drawer-trigger').on('click', function () {
		$(this).toggleClass('active');
		$('.header-wrapper').toggleClass('header-drawer-open');

		// Check if the drawer has the active class and stop/start lenis accordingly
		if ($(this).hasClass('active')) {
			// Stop lenis scrolling when drawer is active
			if (typeof lenis !== 'undefined') {
				// lenis.stop();
			}
		} else {
			// Resume lenis scrolling when drawer is closed
			if (typeof lenis !== 'undefined') {
				// lenis.start();
			}
		}
	});

	if (
		document.querySelectorAll(
			'.button:not(.product-form__submit):not(.cart-remove-button)'
		).length
	) {
		document
			.querySelectorAll(
				'.button:not(.product-form__submit):not(.cart-remove-button)'
			)
			.forEach((item) => {
				let overflowWrapper = item.querySelector('.button-overflow-wrapper');
				let top, bottom;

				if (!overflowWrapper) {
					const originalText = item.textContent.trim();
					item.textContent = '';

					top = document.createElement('div');
					top.classList.add('char-split-top');
					top.textContent = originalText;

					bottom = document.createElement('div');
					bottom.classList.add('char-split-bottom');
					bottom.textContent = originalText;

					overflowWrapper = document.createElement('div');
					overflowWrapper.classList.add('button-overflow-wrapper');
					overflowWrapper.appendChild(top);
					overflowWrapper.appendChild(bottom);

					item.appendChild(overflowWrapper);
				} else {
					top = overflowWrapper.querySelector('.char-split-top');
					bottom = overflowWrapper.querySelector('.char-split-bottom');
				}

				if (top && bottom) {
					const topSplit = new SplitText(top, { type: 'chars' });
					const bottomSplit = new SplitText(bottom, {
						type: 'chars',
					});

					gsap.set(bottomSplit.chars, { yPercent: 100 });

					item.addEventListener('mouseenter', () => {
						topSplit.chars.forEach((char, i) => {
							gsap.to(char, {
								yPercent: -100,
								duration: 0.5,
								ease: 'power2.out',
								delay: i * 0.02,
							});
						});

						bottomSplit.chars.forEach((char, i) => {
							gsap.to(char, {
								yPercent: 0,
								duration: 0.5,
								ease: 'power2.out',
								delay: i * 0.02,
							});
						});
					});

					item.addEventListener('mouseleave', () => {
						topSplit.chars.forEach((char, i) => {
							gsap.to(char, {
								yPercent: 0,
								duration: 0.4,
								ease: 'power2.out',
								delay: i * 0.02,
							});
						});

						bottomSplit.chars.forEach((char, i) => {
							gsap.to(char, {
								yPercent: 100,
								duration: 0.4,
								ease: 'power2.out',
								delay: i * 0.02,
							});
						});
					});
				}
			});
	}

	if ($('.gin-intro-section').length) {
		const el = document.querySelector('.letter-split-reveal');
		let wrapper = el.querySelector('.letter-split-wrapper');
		let clipValue = 'circle(100% at 50% 0%)';

		if (window.innerWidth < 1201) {
			clipValue = 'circle(120% at 50% 0%)';
		}

		if (window.innerWidth < 601) {
			clipValue = 'circle(200% at 50% 0%)';
		}

		if (!wrapper) {
			const text = el.textContent.trim();
			el.textContent = '';

			const top = document.createElement('div');
			top.className = 'gin-char-split-top';
			top.textContent = text;

			const bottom = document.createElement('div');
			bottom.className = 'gin-char-split-bottom';
			bottom.textContent = text;

			wrapper = document.createElement('div');
			wrapper.className = 'letter-split-wrapper';
			wrapper.appendChild(top);
			wrapper.appendChild(bottom);
			el.appendChild(wrapper);
		}

		const top = wrapper.querySelector('.gin-char-split-top');
		const bottom = wrapper.querySelector('.gin-char-split-bottom');

		const topSplit = new SplitText(top, { type: 'chars' });
		const bottomSplit = new SplitText(bottom, { type: 'chars' });

		gsap.set(bottomSplit.chars, { yPercent: 100 });

		const topChars = gsap.utils.toArray('.gin-char-split-top > *');
		const bottomChars = gsap.utils.toArray('.gin-char-split-bottom > *');
		const ginIntroSection = document.querySelector('.gin-intro-section');
		const ginSectionWrapper = document.querySelector('.gin-section-wrapper');
		const ginStickyAddToCart = document.querySelector('.sticky-add-to-cart-wrapper');

		const ginTL = gsap.timeline({
			id: 'GinIntroTimeline',
			scrollTrigger: {
				trigger: ginSectionWrapper,
				start: 'clamp(top top)',
				end: '+=1500px', // Adjust duration as needed
				// pin: ginIntroSection,
				// pinType: 'fixed', // Required for Lenis + native body
				// pinSpacing: true, // Keep spacing to preserve layout
				scrub: true, // Increased scrub value for smoother animation
				invalidateOnRefresh: true,
				ease: 'power2.out',
			},
		});

		gsap.to('.circle-clip', {
			opacity: 1,
			duration: 0.7,
		});

		gsap.to(
			'.bottle-image',
			{
				transform: 'translateY(0)',
				opacity: 1,
				// duration: 0.7,
			},
			'-=0.3'
		);

		ginTL.to(
			'.background-texture',
			{
				opacity: 0,
				duration: 0.5,
			},
			'-=1'
		);

		if (window.innerWidth > 1024) {
			ginTL.to(
				ginStickyAddToCart,
				{
					transform: 'translateY(-130%)',
					duration: 0.7,
					ease: 'power2.out',
				},
				'-=1'
			);
		}

		ginTL.to(
			'.circle-clip',
			{
				clipPath: clipValue,
				duration: 2,
				// duration: ,
			},
			'-=1'
		);

		ginTL.to(
			'.blur-layer',
			{
				opacity: 1,
				scale: 1,
			},
			'-=2'
		);

		ginTL.to(
			'.circle-clip-glow',
			{
				opacity: 1,
				scale: 1,
			},
			'-=1.5'
		);

		ginTL.to(
			ginStickyAddToCart,
			{
				opacity: 0,
				duration: 0.7,
				ease: 'power2.out',
			},
			'-=1.5'
		);

		ginTL.to(
			topChars,
			{
				yPercent: -100,
				duration: 0.7,
				stagger: 0.02,
			},
			'-=2'
		);
		ginTL.to(
			bottomChars,
			{
				yPercent: 0,
				duration: 0.7,
				stagger: 0.02,
			},
			'-=2'
		);

		ginTL.to(
			'.tagline-and-details',
			{
				color: 'white',
				duration: 0.7,
				ease: 'linear',
			},
			'-=2'
		);
		ginTL.to(
			'.product-tagline',
			{
				opacity: 0,
				y: -50,
				duration: 0.7,
				ease: 'linear',
			},
			'-=2'
		);
		ginTL.to(
			'.product-details-inner',
			{
				opacity: 1,
				y: 0,
			},
			'-=2'
		);

		ginTL.to(
			'.gin-play-button',
			{
				pointerEvents: 'none',
				opacity: 0,
			},
			'-=2'
		);

		ginTL.to(
			'.market-container',
			{
				opacity: 1,
				pointerEvents: 'all',
			},
			'-=1'
		);

		gsap.to('.page-content-inner', {
			opacity: 1,
			duration: 0.7,
			ease: 'linear',
			scrollTrigger: {
				trigger: ginSectionWrapper,
				start: 'bottom 100%',
				// scrub: true,
				toggleActions: 'play none none reverse',
			},
		});
	}

	if ($('.content-image-section').length) {
		const contentSections = document.querySelectorAll('.content-image-section');

		contentSections.forEach((section) => {
			const inner = section.querySelector('.inner');

			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: section,
					start: 'top 60%',
					end: 'bottom 50%',
					toggleActions: 'play none none none',
				},
			});
			tl.from(inner, {
				duration: 0.7,
				ease: 'power2.out',
				opacity: 0,
			});
		});
	}

	if ($('.gin-content-image').length) {
		const contentSections = document.querySelectorAll('.gin-content-image .content');
		contentSections.forEach((section) => {
			const paragraphs = section.querySelectorAll('p');
			const headings = section.querySelectorAll('h3');

			// Group each h3 with its following paragraphs until next h3
			headings.forEach((heading, index) => {
				const group = document.createElement('div');
				group.className = 'content-group';
				heading.parentNode.insertBefore(group, heading);
				group.appendChild(heading);

				// Get all paragraphs until next heading
				let currentP = paragraphs[index];
				while (
					currentP &&
					currentP.nextElementSibling &&
					currentP.nextElementSibling.tagName !== 'H3'
				) {
					group.appendChild(currentP);
					currentP = currentP.nextElementSibling;
				}
				// Add the last paragraph if it exists
				if (currentP) {
					group.appendChild(currentP);
				}
			});

			const contentGroups = section.querySelectorAll('.content-group');

			contentGroups.forEach((group, index) => {
				gsap.from(group, {
					opacity: 0,
					duration: 1,
					ease: 'power2.out',
					scrollTrigger: {
						trigger: group,
						start: 'top 80%',
						end: 'top 50%',
						scrub: true,
						toggleActions: 'play none none reverse',
					},
				});
			});
		});

		const imageWrapper = document.querySelector('.gin-image-wrapper');
		const image = imageWrapper.querySelector('img');

		const imageTL = gsap.timeline({
			scrollTrigger: {
				trigger: imageWrapper,
				start: 'top 80%',
				end: 'bottom bottom',
				scrub: true,
			},
		});

		imageTL.to(imageWrapper, {
			opacity: 1,
			duration: 0.7,
			ease: 'power2.out',
		});

		imageTL.to(imageWrapper, {
			clipPath: 'inset(0% 0% 0% 0%)',
			duration: 1,
			ease: 'power2.out',
		});

		imageTL.to(
			image,
			{
				scale: 1,
				duration: 1,
				ease: 'power2.out',
			},
			'-=1'
		);
	}

	if ($('.botanical-slider-section').length) {
		const botanicalSlider = document.querySelector('.botanical-slider');
		const botanicalSwiper = new Swiper(botanicalSlider, {
			loop: true,
			slidesPerView: 'auto',
			centeredSlides: true,
			spaceBetween: 20,
			pagination: {
				el: '.botanical-slider-pagination',
				clickable: true,
			},

			breakpoints: {
				768: {
					slidesPerView: 4,
				},
				1024: {
					slidesPerView: 'auto',
					spaceBetween: 50,
				},
			},

			// arrows
			navigation: {
				nextEl: '.botanical-next',
				prevEl: '.botanical-prev',
			},
		});

		const botanicalSlides = gsap.utils.toArray(
			'.botanical-slide .botanical-slide-inner'
		);

		gsap.to(botanicalSlides, {
			opacity: 1,
			y: 0,
			duration: 0.7,
			stagger: 0.1,
			ease: 'power2.out',
			scrollTrigger: {
				trigger: '.botanical-slider-section',
				start: 'top 80%',
				toggleActions: 'play none none reverse',
			},
		});
	}

	if ($('.sticky-content-and-image').length) {
		if (window.innerWidth > 1024) {
			const stickySections = document.querySelectorAll('.sticky-content-and-image');

			stickySections.forEach((section) => {
				const stickyImages = section.querySelectorAll('.sticky-image-img');
				const stickyContents = section.querySelectorAll('.sticky-content');

				stickyContents.forEach((content, index) => {
					const matchingImage = stickyImages[index];
					const matchingContent = stickyContents[index];
					if (matchingImage) {
						gsap.fromTo(
							matchingImage,
							{
								opacity: 0,
							},
							{
								scrollTrigger: {
									trigger: content,
									start: 'top 85%',
									end: 'bottom 20%',
									scrub: true,
								},
								opacity: 1,
								ease: 'power2.inOut',
							}
						);
					}

					gsap.fromTo(
						matchingContent,
						{
							opacity: 0,
						},
						{
							opacity: 1,
							duration: 0.5,
							ease: 'power2.inOut',
							scrollTrigger: {
								trigger: content,
								start: 'top 85%',
								end: 'bottom 20%',
								scrub: true,
								toggleActions: 'play none none reverse',
							},
						}
					);
				});
			});
		}
	}

	if ($('.expanding-cta-image-wrapper:not(.no-effects)').length) {
		const expandingCTAimages = document.querySelectorAll(
			'.expanding-cta-image-wrapper'
		);

		expandingCTAimages.forEach((expandingCTAimage) => {
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: expandingCTAimage,
					start: 'top 50%',
					end: 'bottom bottom',
					scrub: 1,
					ease: 'power2.out',
					duration: 0.5,
				},
			});

			tl.to(
				expandingCTAimage,
				{
					clipPath: 'inset(0%)',
				},
				'-=0.5'
			);
			tl.from(
				expandingCTAimage.querySelector('.large-parallax'),
				{
					scale: 1.05,
				},
				'-=0.5'
			);
		});
	}

	if ($('.expanding-cta-image-wrapper.no-effect .content').length) {
		const expandingCTAimages = document.querySelectorAll(
			'.expanding-cta-image-wrapper.no-effect .content'
		);

		gsap.from(expandingCTAimages, {
			opacity: 0,
			y: 100,
			duration: 0.7,
			ease: 'power2.out',
			scrollTrigger: {
				trigger: expandingCTAimages,
				start: 'top 50%',
				ease: 'power2.out',
				duration: 0.5,
				markers: true,
			},
		});
	}

	if ($('.kenya-expanding').length) {
		let maskSize = '500% 500%';

		const kenyaExpandingBg = document.querySelector('.kenya-expanding-bg');
		const kenyaExpanding = document.querySelector('.kenya-expanding');
		const kenyaExpandingInner = document.querySelector('.kenya-expanding-inner');
		const kenyaExpandingContent = document.querySelector('.kenya-expanding-content');

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: kenyaExpanding,
				start: 'top top',
				end: '+=500px',
				scrub: 1,
				pin: kenyaExpandingInner,
				pinSpacing: true,
				pinType: 'fixed',
			},
		});

		tl.to(
			kenyaExpandingInner,
			{
				maskSize: maskSize,
			},
			'0'
		);

		tl.to(
			kenyaExpandingBg,
			{
				scale: 1,
			},
			'0'
		);

		tl.from(
			kenyaExpandingContent,
			{
				opacity: 0,
				duration: 0.7,
				ease: 'power2.out',
			},
			'-=0.5'
		);
	}

	// if ($('.product-form__submit').length) {
	// 	gsap.to('.floating-region', {
	// 		opacity: 1,
	// 		pointerEvents: 'all',

	// 		scrollTrigger: {
	// 			trigger: '.product-form__submit',
	// 			start: 'clamp(top 100%)',
	// 			end: 'bottom top',
	// 			toggleActions: 'play none none reverse',
	// 		},
	// 	});
	// }

	// remove all .motion-reduce classes
	document.querySelectorAll('.motion-reduce').forEach((el) => {
		el.classList.remove('motion-reduce');
	});

	$(document).on('click', 'summary', function (e) {
		setTimeout(function () {
			let isOpen = $('summary[aria-expanded="true"]').length > 0;
			$('.header-wrapper').toggleClass('menu-open', isOpen);

			// If a summary is open, add a one-time click handler to body to close it
			if (isOpen) {
				// Remove any previous handler to avoid stacking
				$(document).off('click.closeSummary');
				$(document).on('click.closeSummary', function (event) {
					// If the click is outside any open summary or its parent details
					if (
						!$(event.target).closest(
							'details[open], summary[aria-expanded="true"]'
						).length
					) {
						// Close all open details
						$('details[open]').removeAttr('open');
						// Remove menu-open class
						$('.header-wrapper').removeClass('menu-open');
						// Remove this handler
						$(document).off('click.closeSummary');
					}
				});
			} else {
				// If not open, remove the handler
				$(document).off('click.closeSummary');
			}
		}, 0);
	});

	if ($('.content-card-slider').length) {
		const contentCardSlider = new Swiper('.content-card-slider', {
			loop: false,
			slidesPerView: 'auto',
			spaceBetween: 10,
			pagination: {
				el: '.card-slider-pagination',
				clickable: true,
			},

			breakpoints: {
				768: {
					// slidesPerView: 3,
				},
				1024: {
					// slidesPerView: 4,
					spaceBetween: 20,
				},
			},
		});

		const cardItems = gsap.utils.toArray('.card-slide .card-item');

		gsap.from(cardItems, {
			opacity: 0,
			duration: 0.7,
			stagger: 0.1,
			scrollTrigger: {
				trigger: cardItems,
				start: 'top 90%',
				toggleActions: 'play none none reverse',
			},
		});
	}

	// end of ready
});

/*
This helper function makes a group of elements animate along the x-axis in a seamless, responsive loop.

Features:
- Uses xPercent so that even if the widths change (like if the window gets resized), it should still work in most cases.
- When each item animates to the left or right enough, it will loop back to the other side
- Optionally pass in a config object with values like "speed" (default: 1, which travels at roughly 100 pixels per second), paused (boolean),  repeat, reversed, and paddingRight.
- The returned timeline will have the following methods added to it:
- next() - animates to the next element using a timeline.tweenTo() which it returns. You can pass in a vars object to control duration, easing, etc.
- previous() - animates to the previous element using a timeline.tweenTo() which it returns. You can pass in a vars object to control duration, easing, etc.
- toIndex() - pass in a zero-based index value of the element that it should animate to, and optionally pass in a vars object to control duration, easing, etc. Always goes in the shortest direction
- current() - returns the current index (if an animation is in-progress, it reflects the final index)
- times - an Array of the times on the timeline where each element hits the "starting" spot. There's also a label added accordingly, so "label1" is when the 2nd element reaches the start.
*/
function horizontalLoop(items, config) {
	items = gsap.utils.toArray(items);
	config = config || {};
	let tl = gsap.timeline({
			repeat: config.repeat,
			paused: config.paused,
			defaults: { ease: 'none' },
			onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100),
		}),
		length = items.length,
		startX = items[0].offsetLeft,
		times = [],
		widths = [],
		xPercents = [],
		curIndex = 0,
		pixelsPerSecond = (config.speed || 1) * 100,
		snap = config.snap === false ? (v) => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
		totalWidth,
		curX,
		distanceToStart,
		distanceToLoop,
		item,
		i;
	gsap.set(items, {
		// convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
		xPercent: (i, el) => {
			let w = (widths[i] = parseFloat(gsap.getProperty(el, 'width', 'px')));
			xPercents[i] = snap(
				(parseFloat(gsap.getProperty(el, 'x', 'px')) / w) * 100 +
					gsap.getProperty(el, 'xPercent')
			);
			return xPercents[i];
		},
	});
	gsap.set(items, { x: 0 });
	totalWidth =
		items[length - 1].offsetLeft +
		(xPercents[length - 1] / 100) * widths[length - 1] -
		startX +
		items[length - 1].offsetWidth * gsap.getProperty(items[length - 1], 'scaleX') +
		(parseFloat(config.paddingRight) || 0);
	for (i = 0; i < length; i++) {
		item = items[i];
		curX = (xPercents[i] / 100) * widths[i];
		distanceToStart = item.offsetLeft + curX - startX;
		distanceToLoop = distanceToStart + widths[i] * gsap.getProperty(item, 'scaleX');
		tl.to(
			item,
			{
				xPercent: snap(((curX - distanceToLoop) / widths[i]) * 100),
				duration: distanceToLoop / pixelsPerSecond,
			},
			0
		)
			.fromTo(
				item,
				{
					xPercent: snap(
						((curX - distanceToLoop + totalWidth) / widths[i]) * 100
					),
				},
				{
					xPercent: xPercents[i],
					duration:
						(curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond,
					immediateRender: false,
				},
				distanceToLoop / pixelsPerSecond
			)
			.add('label' + i, distanceToStart / pixelsPerSecond);
		times[i] = distanceToStart / pixelsPerSecond;
	}
	function toIndex(index, vars) {
		vars = vars || {};
		Math.abs(index - curIndex) > length / 2 &&
			(index += index > curIndex ? -length : length); // always go in the shortest direction
		let newIndex = gsap.utils.wrap(0, length, index),
			time = times[newIndex];
		if (time > tl.time() !== index > curIndex) {
			// if we're wrapping the timeline's playhead, make the proper adjustments
			vars.modifiers = { time: gsap.utils.wrap(0, tl.duration()) };
			time += tl.duration() * (index > curIndex ? 1 : -1);
		}
		curIndex = newIndex;
		vars.overwrite = true;
		return tl.tweenTo(time, vars);
	}
	tl.next = (vars) => toIndex(curIndex + 1, vars);
	tl.previous = (vars) => toIndex(curIndex - 1, vars);
	tl.current = () => curIndex;
	tl.toIndex = (index, vars) => toIndex(index, vars);
	tl.times = times;
	tl.progress(1, true).progress(0, true); // pre-render for performance
	if (config.reversed) {
		tl.vars.onReverseComplete();
		tl.reverse();
	}
	return tl;
}
